export interface Interval {
  startDate: string;
  endDate: string;
}

export enum EReportsTabs {
  FINANCIAL = 'financialreports',
  PAYOUTS = 'payouts'
}

export enum EReportStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CREATED = 'CREATED',
  FAILED = 'FAILED'
}

export const EReportStatusSearchOrder: EReportStatus[] = [
  EReportStatus.IN_PROGRESS,
  EReportStatus.CREATED,
  EReportStatus.FAILED
];

export const reportStatusDisplayLabels: Record<EReportStatus, string> = {
  [EReportStatus.IN_PROGRESS]: 'Processing',
  [EReportStatus.CREATED]: 'Done',
  [EReportStatus.FAILED]: 'Failed'
};

export enum EPayoutStatus {
  SUCCESS = 'SUCCESS'
}

export interface Report {
  reportId: string;
  filename: string;
  createdBy: string;
  status: EReportStatus;
  interval: Interval;
  createdAt: Date;
  updatedAt: Date;
}

// API response includes additional fields not in the base Report interface
export interface ReportApiResponse extends Omit<Report, 'createdAt' | 'updatedAt'> {
  publishers: string[];
  timestamp?: string;
  createdAt?: string;
  createdDate?: string;
  updatedAt?: string;
}

export interface Payout {
  transferDate: Date;
  amount: number;
  currency: string;
  period: Interval;
  status: EPayoutStatus;
  reference: string;
  fileName: string;
}

export interface PayoutApiResponse {
  id: string;
  transferDate: Date;
  amount: number;
  currency: string;
  period: Interval;
  status: EPayoutStatus;
  reference: string;
  fileName: string;
  publisherId?: string;
}

export interface PayoutRequest {
  transferDate: Date;
  amount: number;
  currency: string;
  period: Interval;
  status: EPayoutStatus;
  reference: string;
  payoutFile: File;
}

